import {
  ADMIN_MODULE,
  ADMIN_ACTIONS,
  ADMIN_RESOURCES
} from "../constants/account.constants.js";
import { hasPermissions } from "./index.js";

export function canAccessAccountAdministration() {
  const ACCOUNT_ADMINISTRATION_RESOURCES = [
    ADMIN_RESOURCES.USER_PROVISIONING,
    ADMIN_RESOURCES.USER_MANAGEMENT,
    ADMIN_RESOURCES.ACCOUNT_AUDITLOG,
    ADMIN_RESOURCES.USER_AUDITLOG,
    ADMIN_RESOURCES.BILLING,
    ADMIN_RESOURCES.ENVIRONMENTS,
    ADMIN_RESOURCES.NOTIFICATION_SETTING,
    ADMIN_RESOURCES.FLOW_SETTING,
    ADMIN_RESOURCES.TASK_DELEGATION,
    ADMIN_RESOURCES.SERVICE_ACCOUNT
  ];

  const _canAccessAccountAdministration = () =>
    ACCOUNT_ADMINISTRATION_RESOURCES.some((resource) =>
      hasPermissions({
        module: ADMIN_MODULE,
        resource: resource,
        actions: [ADMIN_ACTIONS.READ]
      })
    );

  return canAccessAccountSettings() || _canAccessAccountAdministration();
}

export function canAccessAccountSettings() {
  const ACCOUNT_SETTINGS_RESOURCES = [
    ADMIN_RESOURCES.ACCOUNT_DETAILS,
    ADMIN_RESOURCES.ACCOUNT_CUSTOMIZATION,
    ADMIN_RESOURCES.CONNECTED_DOMAIN,
    ADMIN_RESOURCES.FORMAT_SETTING,
    ADMIN_RESOURCES.HOLIDAY_SETTING,
    ADMIN_RESOURCES.UPLOAD_SETTING,
    ADMIN_RESOURCES.GEOLOCATION_SETTING
  ];

  const _canAccessAccountSettings = () =>
    ACCOUNT_SETTINGS_RESOURCES.some((resource) =>
      hasPermissions({
        module: ADMIN_MODULE,
        resource: resource,
        actions: [ADMIN_ACTIONS.READ]
      })
    );

  return canAccessAccountSecurity() || _canAccessAccountSettings();
}

export function canAccessAccountSecurity() {
  const ACCOUNT_SECURITY_RESOURCES = [
    ADMIN_RESOURCES.SIGNIN_PREFERENCE,
    ADMIN_RESOURCES.SIGNUP_PREFERENCE,
    ADMIN_RESOURCES.ACCESS_KEY,
    ADMIN_RESOURCES.IMPERSONATION_SECURITY
  ];

  return ACCOUNT_SECURITY_RESOURCES.some((resource) =>
    hasPermissions({
      module: ADMIN_MODULE,
      resource: resource,
      actions: [ADMIN_ACTIONS.READ]
    })
  );
}
